export default __webpack_public_path__ + "static/media/past-due.6dc637fb.svg";